import { FaHome } from "react-icons/fa";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.documentListItem()
    .schemaType(`homepage`)
    .icon(FaHome)
    .id(`homepage`)
    .title(`Homepage`);
